(function() { window.GUID_e21f94c3_9f4b_4854_ab51_575b88a18260 = { getGuid: function() { return "e21f94c3-9f4b-4854-ab51-575b88a18260"; } }; })();
Number.prototype.map = function (in_min, in_max, out_min, out_max) {
    return (this - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
};
// var num = 5
// num.map(0,10,0,100)  //retourne 50

//# sourceMappingURL=cs.math.js.map
